import React from 'react';

const IconVelvet = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" rx="2" fill="#AF87A1" />
    <path
      d="M6.97 3.75L6.2 6.18C6.07 6.59 5.93 7.07 5.87 7.33C5.81 7.08 5.67 6.58 5.54 6.18L4.77 3.75H3.25L5.14 9H6.56L8.45 3.75H6.97Z"
      fill="white"
    />
  </svg>
);
export default IconVelvet;
